// -*-mode: rjsx -*-
import React from "react";
import AppContext from "./AppContext.js"

import { makeStyles } from '@material-ui/core/styles';

// LOGGING SETUP
import appConfig from "./App.config.js"
const log = appConfig.getLogger("<JsonPreloader>")

const useStyles = makeStyles(theme => ({
    root: {
        display: "none",
        color: "white",
        background: "black",
    }
}))

const JsonPreloader = props => {

    const classes = useStyles()
    
    const appContext = React.useContext(AppContext)

    // useEffect1
    React.useEffect(() => {
        if(appContext.isPreloading) {
            log.trace("useEffect1(): isPreloading is set, do preload...")
            appContext.preload(["NATIONAL", "STATE", "USCD", "SSD"])
            appContext.setPreloading(false)        
        }
    })

    log.trace("appContext =",appContext)

    let jsonCount = 0
    Object.entries(appContext.jsons).forEach(([key, json]) => {
        log.trace("key =",key)
        log.trace("json =",json)
        if(json.isLoading) {
            jsonCount++
        }
        log.trace("jsonCount =",jsonCount)
    })
        
    return (
        <div className={classes.root}>
        {appContext.isPreloading ?
            <div>JsonPreloader launch...</div>
         : <div>JsonPreloader launch finished</div>
        }
        {jsonCount && jsonCount > 0 ?
         <div>JsonPreloader loading json...{jsonCount}</div>
         : <div>JsonPreloader loading finished</div>
        }
        </div>
    )
}

export default JsonPreloader
